import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule, SvgIconModule } from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

import { HeaderMetaNavComponent } from './header-meta-nav.component';
import { MaxWidthDirective } from './max-width.directive';
import { MetaNavItemComponent } from './meta-nav-item.component';

@NgModule({
  declarations: [HeaderMetaNavComponent, MetaNavItemComponent, MaxWidthDirective],
  imports: [CommonModule, SvgIconModule, ButtonModule, AnalyticsModule],
  exports: [HeaderMetaNavComponent, MetaNavItemComponent, MaxWidthDirective]
})
export class HeaderMetaNavModule {}
